import { render, staticRenderFns } from "./PasswordNew.vue?vue&type=template&id=61268c1c&"
import script from "./PasswordNew.vue?vue&type=script&lang=js&"
export * from "./PasswordNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports